import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { PrimengModule } from "../../../primeng/primeng.module";
import { InvoicedetailsComponent } from "./invoicedetails/invoicedetails.component";
import { InvoicefComponent } from "./invoicef/invoicef.component";


const COMPONENTS = [
    InvoicefComponent,
    InvoicedetailsComponent
   
];
@NgModule({
    declarations: COMPONENTS,
    imports: [CommonModule, PrimengModule],
    exports: COMPONENTS
})
export class InvoiceModule {}
